

module.exports = __webpack_require__.stylable.create(
    "divider3544298721",
    {"classes":{"root":"divider3544298721__root"},"vars":{},"stVars":{"dividerHeight":"1px","dividerBackgroundColor":"black","dividerOpacity":"initial","dividerMarginTop":"initial","dividerMarginBottom":"initial"},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/wix-ui-core/dist/src/components/deprecated/divider/Divider.st.css */ 439,
    null
);
